import React from 'react';
import MenuButton from '../menubutton';
import Header from '../header';
import SideBar from '../sidebar';

export default function RootLayout({ children }) {
	return (
		<div className="flex flex-col relative">
			<Header />
			<MenuButton />
			<div className="flex-1 md:flex-row md:flex">
				<SideBar />
				<main className="p-4 pt-10 max-h-screen bg-white basis-full grow md:basis-4/5 overflow-scroll">
					{children}
				</main>
			</div>
		</div>
	);
}
